import React from 'react';
import './SnapBillPlanCreditNote.css';

export default function SnapBillPlanCreditNote() {
  return (
    <div className="snap-bill-plan-credit-note">
      <p className="snap-bill-plan-credit-note__body">
        Each document processing is charged per page. Processing charge per page is based on the value set in your account.
      </p>
      <p className="snap-bill-plan-credit-note__note">
        <strong>Note:</strong> 1 credit is $1. Credits are utilized for AI processing and is based on
        the type of service usage.
      </p>
    </div>
  );
}
